module.exports = __webpack_public_path__ + "img/1F3F3-FE0F-200D-1F7E6-200D-1F30C.4428a0ad.svg";